import type { ColumnConfigEntry } from '@erp/shared-types';
import { DEFAULT_TASK_QUEUE_COLUMNS } from '../useTasksQueuePage';

/**
 * Built-in task-page column set: the `/tasks` defaults with the type column
 * (every row shares the page's pinned type) swapped for the anchor-summary
 * column — the business entity each task is working on.
 */
export function buildTaskPageQueueColumns(
  anchorHeader: string,
): ColumnConfigEntry[] {
  return DEFAULT_TASK_QUEUE_COLUMNS.map((column) =>
    column.id === 'type'
      ? { id: 'anchor', header: anchorHeader, apiField: 'anchorEntityId' }
      : column,
  );
}
